import appConfig from 'configs/app.config'
import { TOKEN_TYPE, REQUEST_HEADER_AUTH_KEY } from 'constants/api.constant'
import { PERSIST_STORE_NAME } from 'constants/app.constant'
import deepParseJson from 'utils/deepParseJson'
import store from 'store'
import { onSignOutSuccess } from 'store/auth/sessionSlice'

const PUBLIC_API_SEGMENTS = [
    'account/login',
    'account/posvendorlogin',
    'account/sendotpapp',
    'account/signup',
    'account/forgetpassword',
    'account/setnewpassword',
    'account/validateotp',
    'resetpassword/',
    'account/moveactivetransactionstoinreview',
    'account/autoapproveinreviewtransactions',
    'account/autocompletealllpasasync',
    'account/autoapprovelpa',
]

export function isPublicApiUrl(url) {
    if (!url) return false
    const path = String(url).toLowerCase()
    return PUBLIC_API_SEGMENTS.some((segment) => path.includes(segment))
}

export function getAccessToken() {
    try {
        const stored = localStorage.getItem('LPA_Admin')
        if (stored) {
            const parsed = JSON.parse(stored)
            if (parsed?.token) return parsed.token
        }
    } catch {
        // ignore parse errors
    }

    try {
        const rawPersist = localStorage.getItem(PERSIST_STORE_NAME)
        if (rawPersist) {
            const persistData = deepParseJson(rawPersist)
            const token = persistData?.auth?.session?.token
            if (token) return token
        }
    } catch {
        // ignore parse errors
    }

    return null
}

export function buildAuthHeaders(url, existingHeaders = {}) {
    const headers = new Headers(existingHeaders)

    if (!isPublicApiUrl(url)) {
        const token = getAccessToken()
        if (token) {
            headers.set(REQUEST_HEADER_AUTH_KEY, `${TOKEN_TYPE}${token}`)
        }
    }

    return headers
}

export function handleUnauthorized() {
    localStorage.removeItem('LPA_Admin')
    localStorage.removeItem('LPA_Menu')
    localStorage.removeItem('items')
    localStorage.removeItem('business')
    store.dispatch(onSignOutSuccess())

    const signInPath = appConfig.unAuthenticatedEntryPath
    if (!window.location.pathname.startsWith(signInPath)) {
        window.location.href = signInPath
    }
}
